// extracted by mini-css-extract-plugin
module.exports = {"Status":"Status_Status__1Ma2r","Blue":"Status_Blue__13Pev","Yellow":"Status_Yellow__2CN57","Orange":"Status_Orange__KqZfV","Green":"Status_Green__2KsUO","Red":"Status_Red__3XtxM"};